import { render } from "./NavigationSidebar.vue?vue&type=template&id=a2c4befc&scoped=true"
import script from "./NavigationSidebar.vue?vue&type=script&lang=js"
export * from "./NavigationSidebar.vue?vue&type=script&lang=js"

import "./NavigationSidebar.vue?vue&type=style&index=0&id=a2c4befc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2c4befc"]])

export default __exports__